import { lazy } from 'react';
import { withSuspense } from '../utils/withSuspense';

const ActiveBeautyBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ActiveBeautyBrandIcon" */ '../Atoms/Logos/logos/ActiveBeautyBrand'
      ),
  ),
  null,
);
const AlverdeBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "AlverdeBrandIcon" */ '../Atoms/Logos/logos/AlverdeBrand'
      ),
  ),
  null,
);

const AndroidShareIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "AndroidShareIcon" */ '../Atoms/Icon/dm/AndroidShare'
      ),
  ),
  null,
);

const AngleDownIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "AngleDownIcon" */ '../Atoms/Icon/dm/AngleDown'
      ),
  ),
  null,
);

const AngleLeftIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/AngleLeft'),
  ),
  null,
);
const AngleRightIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/AngleRight'
      ),
  ),
  null,
);
const AngleUpIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "AngleUpIcon" */ '../Atoms/Icon/dm/AngleUp'),
  ),
  null,
);
const ArrowDownIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ArrowDownIcon" */ '../Atoms/Icon/dm/ArrowDown'
      ),
  ),
  null,
);
const ArrowLeftIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/ArrowLeft'),
  ),
  null,
);
const ArrowRightIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/ArrowRight'
      ),
  ),
  null,
);
const ArrowUpIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "ArrowUpIcon" */ '../Atoms/Icon/dm/ArrowUp'),
  ),
  null,
);
const BagExpressIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "BagExpressIcon" */ '../Atoms/Icon/dm/BagExpress'
      ),
  ),
  null,
);
const BestRatedIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "BestRatedIcon" */ '../Atoms/Icon/dm/BestRated'
      ),
  ),
  null,
);
const BarcodeIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "BarcodeIcon" */ '../Atoms/Icon/dm/Barcode'),
  ),
  null,
);
const CardsIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "CardsIcon" */ '../Atoms/Icon/dm/Cards'),
  ),
  null,
);
const CartIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/Cart'),
  ),
  null,
);
const CartEuroIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CartEuroIcon" */ '../Atoms/Icon/dm/CartEuro'
      ),
  ),
  null,
);
const CatHeadIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "CatHeadIcon" */ '../Atoms/Icon/dm/CatHead'),
  ),
  null,
);
const CheckIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "CheckIcon" */ '../Atoms/Icon/dm/Check'),
  ),
  null,
);
const CheckCircleIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CheckCircleIcon" */ '../Atoms/Icon/dm/CheckCircle'
      ),
  ),
  null,
);
const ClockIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "ClockIcon" */ '../Atoms/Icon/dm/Clock'),
  ),
  null,
);
const ClockAliveIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ClockAliveIcon" */ '../Atoms/Icon/dm/ClockAlive'
      ),
  ),
  null,
);
const CrossCircleIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CrossCircleIcon" */ '../Atoms/Icon/dm/CrossCircle'
      ),
  ),
  null,
);
const CheckCircleInvertedIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CheckCircleInvertedIcon" */ '../Atoms/Icon/dm/CheckCircleInverted'
      ),
  ),
  null,
);
const CoinStackIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CoinStackIcon" */ '../Atoms/Icon/dm/CoinStack'
      ),
  ),
  null,
);
const ControlsIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/Controls'),
  ),
  null,
);
const CouponIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "CouponIcon" */ '../Atoms/Icon/dm/Coupon'),
  ),
  null,
);
const CrossCircleInvertedIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CrossCircleInvertedIcon" */ '../Atoms/Icon/dm/CrossCircleInverted'
      ),
  ),
  null,
);
const CrossIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "CrossIcon" */ '../Atoms/Icon/dm/Cross'),
  ),
  null,
);
const CrosshairIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CrosshairIcon" */ '../Atoms/Icon/dm/Crosshair'
      ),
  ),
  null,
);
const DmActiveBeautyBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmActiveBeautyBrandIcon" */ '../Atoms/Logos/logos/DmActiveBeautyBrand'
      ),
  ),
  null,
);
const DmActiveBeautySquareBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmActiveBeautySquareBrandIcon" */ '../Atoms/Logos/logos/DmActiveBeautySquareBrand'
      ),
  ),
  null,
);
const DmBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Logos/logos/DmBrand'
      ),
  ),
  null,
);
const DmBrandClaimIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmBrandClaimIcon" */ '../Atoms/Logos/logos/DmBrandClaim'
      ),
  ),
  null,
);
const DmBrandClaimNegIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmBrandClaimNegIcon" */ '../Atoms/Logos/logos/DmBrandClaimNeg'
      ),
  ),
  null,
);
const DmBrandMonoIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmBrandMonoIcon" */ '../Atoms/Logos/logos/DmBrandMono'
      ),
  ),
  null,
);
const DmBrandSmartphoneIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmBrandSmartphoneIcon" */ '../Atoms/Icon/dm/DmBrandSmartphone'
      ),
  ),
  null,
);
const DmBusinessBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmBusinessBrandIcon" */ '../Atoms/Logos/logos/DmBusinessBrand'
      ),
  ),
  null,
);
const DmBusinessBrandMonoIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmBusinessBrandMonoIcon" */ '../Atoms/Logos/logos/DmBusinessBrandMono'
      ),
  ),
  null,
);
const DmFriseurstudioBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmFriseurstudioBrandIcon" */ '../Atoms/Logos/logos/DmFriseurstudioBrand'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIcon" */ '../Atoms/Logos/logos/DmImmerguenstigBrand'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconBA = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconBA" */ '../Atoms/Logos/logos/DmImmerguenstigBrandBA'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconBG = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconBG" */ '../Atoms/Logos/logos/DmImmerguenstigBrandBG'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconCZ = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconCZ" */ '../Atoms/Logos/logos/DmImmerguenstigBrandCZ'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconHR = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconHR" */ '../Atoms/Logos/logos/DmImmerguenstigBrandHR'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconHU = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconHU" */ '../Atoms/Logos/logos/DmImmerguenstigBrandHU'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconIT = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconIT" */ '../Atoms/Logos/logos/DmImmerguenstigBrandIT'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconPL = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconPL" */ '../Atoms/Logos/logos/DmImmerguenstigBrandPL'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconSI = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconSI" */ '../Atoms/Logos/logos/DmImmerguenstigBrandSI'
      ),
  ),
  null,
);
const DmImmerguenstigBrandIconSK = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmImmerguenstigBrandIconSK" */ '../Atoms/Logos/logos/DmImmerguenstigBrandSK'
      ),
  ),
  null,
);
const DmKosmetikstudioBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmKosmetikstudioBrandIcon" */ '../Atoms/Logos/logos/DmKosmetikstudioBrand'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIcon" */ '../Atoms/Logos/logos/DmMiteinanderBrandMono'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconBA = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconBA" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoBA'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconBG = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconBG" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoBG'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconCZ = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconCZ" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoCZ'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconHU = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconHU" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoHU'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconRO = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconRO" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoRO'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconSI = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconSI" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoSI'
      ),
  ),
  null,
);
const DmMiteinanderBrandMonoIconSK = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmMiteinanderBrandMonoIconSK" */ '../Atoms/Logos/logos/DmMiteinanderBrandMonoSK'
      ),
  ),
  null,
);
const DmProdukttesterLogoIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmProdukttesterLogoIcon" */ '../Atoms/Logos/logos/DmProdukttesterLogo'
      ),
  ),
  null,
);
const DmProdukttesterLogoIconHR = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmProdukttesterLogoIconHR" */ '../Atoms/Logos/logos/DmProdukttesterLogoHR'
      ),
  ),
  null,
);
const DmProdukttesterLogoIconHU = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmProdukttesterLogoIconHU" */ '../Atoms/Logos/logos/DmProdukttesterLogoHU'
      ),
  ),
  null,
);
const DmProdukttesterLogoIconSK = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmProdukttesterLogoIconSK" */ '../Atoms/Logos/logos/DmProdukttesterLogoSK'
      ),
  ),
  null,
);
const DmProdukttesterLogoIconSL = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmProdukttesterLogoIconSL" */ '../Atoms/Logos/logos/DmProdukttesterLogoSL'
      ),
  ),
  null,
);
const DmStudioBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "DmStudioBrandIcon" */ '../Atoms/Logos/logos/DmStudioBrand'
      ),
  ),
  null,
);
const ExclamationCircleIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ExclamationCircleIcon" */ '../Atoms/Icon/dm/ExclamationCircle'
      ),
  ),
  null,
);
const ExclamationCircleStrokeIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ExclamationCircleStrokeIcon" */ '../Atoms/Icon/dm/ExclamationCircleStroke'
      ),
  ),
  null,
);
const ExpressDeliveryIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ExpressDeliveryIcon" */ '../Atoms/Icon/dm/ExpressDelivery'
      ),
  ),
  null,
);
const EyeIcon = withSuspense(
  lazy(() => import(/* webpackChunkName: "EyeIcon" */ '../Atoms/Icon/dm/Eye')),
  null,
);
const EyeStrokeIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "EyeStrokeIcon" */ '../Atoms/Icon/dm/EyeStroke'
      ),
  ),
  null,
);
const FacebookBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "FacebookBrandIcon" */ '../Atoms/Logos/logos/FacebookBrand'
      ),
  ),
  null,
);
const GearIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "GearIcon" */ '../Atoms/Icon/dm/Gear'),
  ),
  null,
);
const GiftIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "GiftIcon" */ '../Atoms/Icon/dm/Gift'),
  ),
  null,
);
const GiftCardIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "GiftIcon" */ '../Atoms/Icon/dm/GiftCard'),
  ),
  null,
);
const GlueckskindBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Logos/logos/GlueckskindBrand'
      ),
  ),
  null,
);
const GlueckskindBrandSquareIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "GlueckskindBrandSquareIcon" */ '../Atoms/Logos/logos/GlueckskindBrandSquare'
      ),
  ),
  null,
);
const GlueckskindBrandMonoSquareIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "GlueckskindBrandMonoSquareIcon" */ '../Atoms/Logos/logos/GlueckskindBrandMonoSquare'
      ),
  ),
  null,
);
const GlueckskindBrandMonoIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "GlueckskindBrandMonoIcon" */ '../Atoms/Logos/logos/GlueckskindBrandMono'
      ),
  ),
  null,
);
const HairdresserCosmeticToolsIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "HairdresserCosmeticToolsIcon" */ '../Atoms/Icon/dm/HairdresserCosmeticTools'
      ),
  ),
  null,
);
const HeartIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/Heart'),
  ),
  null,
);
const HeartStrokeIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/HeartStroke'
      ),
  ),
  null,
);
const InfoIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "InfoIcon" */ '../Atoms/Icon/dm/Info'),
  ),
  null,
);
const InfoStrokeIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/InfoStroke'
      ),
  ),
  null,
);
const LetterCheckIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "LetterCheckIcon" */ '../Atoms/Icon/dm/LetterCheck'
      ),
  ),
  null,
);
const ListCheckIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ListCheckIcon" */ '../Atoms/Icon/dm/ListCheck'
      ),
  ),
  null,
);
const MailIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "MailIcon" */ '../Atoms/Icon/dm/Mail'),
  ),
  null,
);
const MailCheckIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MailCheckIcon" */ '../Atoms/Icon/dm/MailCheck'
      ),
  ),
  null,
);
const MailQuestionMarkIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MailQuestionMarkIcon" */ '../Atoms/Icon/dm/MailQuestionMark'
      ),
  ),
  null,
);
const MapsMarkerIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/MapsMarker'
      ),
  ),
  null,
);
const MapsMarkerHeartIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/MapsMarkerHeart'
      ),
  ),
  null,
);
const MapsMarkerCheckIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/MapsMarkerCheck'
      ),
  ),
  null,
);
const MapsMarkerCheckHeartIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MapsMarkerCheckHeartIcon" */ '../Atoms/Icon/dm/MapsMarkerCheckHeart'
      ),
  ),
  null,
);
const MapsMarkerCrossIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/MapsMarkerCross'
      ),
  ),
  null,
);
const MapsMarkerCrossHeartIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MapsMarkerCrossHeartIcon" */ '../Atoms/Icon/dm/MapsMarkerCrossHeart'
      ),
  ),
  null,
);
const MapsMarkerDmBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MapsMarkerDmBrandIcon" */ '../Atoms/Icon/dm/MapsMarkerDmBrand'
      ),
  ),
  null,
);
const MapsMarkerDmBrandHeartIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MapsMarkerDmBrandHeartIcon" */ '../Atoms/Icon/dm/MapsMarkerDmBrandHeart'
      ),
  ),
  null,
);
const MapsMarkerHouseIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MapsMarkerHouseIcon" */ '../Atoms/Icon/dm/MapsMarkerHouse'
      ),
  ),
  null,
);
const MeinDmAppIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MeinDmAppIcon" */ '../Atoms/Logos/logos/MeinDmApp'
      ),
  ),
  null,
);
const MenuIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/Menu'),
  ),
  null,
);
const MinusIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "MinusIcon" */ '../Atoms/Icon/dm/Minus'),
  ),
  null,
);
const NewIcon = withSuspense(
  lazy(() => import(/* webpackChunkName: "NewIcon" */ '../Atoms/Icon/dm/New')),
  null,
);
const PackageArrowIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PackageArrowIcon" */ '../Atoms/Icon/dm/PackageArrow'
      ),
  ),
  null,
);
const PackageCloseIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/PackageClose'
      ),
  ),
  null,
);
const PackageCrossIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PackageCrossIcon" */ '../Atoms/Icon/dm/PackageCross'
      ),
  ),
  null,
);
const PackageOpenIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PackageOpenIcon" */ '../Atoms/Icon/dm/PackageOpen'
      ),
  ),
  null,
);
const PaybackBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Logos/logos/PaybackBrand'
      ),
  ),
  null,
);
const PaybackBrandBigIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Logos/logos/PaybackBrandBig'
      ),
  ),
  null,
);
const PaybackLogotypeIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "IconSprite" */ '../Atoms/Logos/logos/PaybackLogotype'
      ),
  ),
  null,
);
const PencilIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "PencilIcon" */ '../Atoms/Icon/dm/Pencil'),
  ),
  null,
);
const PhotoAlbumIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PhotoAlbumIcon" */ '../Atoms/Icon/dm/PhotoAlbum'
      ),
  ),
  null,
);
const PlayIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/Play'),
  ),
  null,
);
const PlusIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "PlusIcon" */ '../Atoms/Icon/dm/Plus'),
  ),
  null,
);
const PlusCircleIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PlusCircleIcon" */ '../Atoms/Icon/dm/PlusCircle'
      ),
  ),
  null,
);
const PoweredByDmBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PoweredByDmBrandIcon" */ '../Atoms/Logos/logos/PoweredByDmBrand'
      ),
  ),
  null,
);
const ProductsIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ProductsIcon" */ '../Atoms/Icon/dm/Products'
      ),
  ),
  null,
);
const QuadArrowRightIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "QuadArrowRightIcon" */ '../Atoms/Icon/dm/QuadArrowRight'
      ),
  ),
  null,
);
const QuadArrowTopIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "QuadArrowTopIcon" */ '../Atoms/Icon/dm/QuadArrowTop'
      ),
  ),
  null,
);
const QuestionCircleIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "QuestionCircleIcon" */ '../Atoms/Icon/dm/QuestionCircle'
      ),
  ),
  null,
);
const SearchIcon = withSuspense(
  lazy(
    () =>
      import(/* webpackChunkName: "SearchIcon" */ '../Atoms/Icon/dm/Search'),
  ),
  null,
);
const SearchCategoryIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "SearchCategoryIcon" */ '../Atoms/Icon/dm/SearchCategory'
      ),
  ),
  null,
);
const SeinzBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "SeinzBrandIcon" */ '../Atoms/Logos/logos/SeinzBrand'
      ),
  ),
  null,
);
const SeinzBrandWhiteIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "SeinzBrandWhiteIcon" */ '../Atoms/Logos/logos/SeinzBrandWhite'
      ),
  ),
  null,
);
const StarIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "StarIcon" */ '../Atoms/Icon/dm/Star'),
  ),
  null,
);
const StoreIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "StoreIcon" */ '../Atoms/Icon/dm/Store'),
  ),
  null,
);
const StoreArrowIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "StoreArrowIcon" */ '../Atoms/Icon/dm/StoreArrow'
      ),
  ),
  null,
);

const StoreCheckIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "StoreCheckIcon" */ '../Atoms/Icon/dm/StoreCheck'
      ),
  ),
  null,
);
const StoreExpressDeliveryIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "StoreExpressDeliveryIcon" */ '../Atoms/Icon/dm/StoreExpressDelivery'
      ),
  ),
  null,
);
const TrashIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "TrashIcon" */ '../Atoms/Icon/dm/Trash'),
  ),
  null,
);
const TruckIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/Truck'),
  ),
  null,
);
const UnserDmBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "UnserDmBrandIcon" */ '../Atoms/Logos/logos/UnserDmBrand'
      ),
  ),
  null,
);
const UserIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "IconSprite" */ '../Atoms/Icon/dm/User'),
  ),
  null,
);
const UserCheckIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "UserCheckIcon" */ '../Atoms/Icon/dm/UserCheck'
      ),
  ),
  null,
);
const UserCrossIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "UserCrossIcon" */ '../Atoms/Icon/dm/UserCross'
      ),
  ),
  null,
);
const UsersIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "UsersIcon" */ '../Atoms/Icon/dm/Users'),
  ),
  null,
);
const VirusIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "VirusIcon" */ '../Atoms/Icon/dm/Virus'),
  ),
  null,
);
const WhatsappBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "WhatsappBrandIcon" */ '../Atoms/Logos/logos/WhatsappBrand'
      ),
  ),
  null,
);
const PaperBagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PaperBagIcon" */ '../Atoms/Icon/dm/PaperBag'
      ),
  ),
  null,
);
const AmericanExpressBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "AmericanExpressBrandIcon" */ '../Atoms/Logos/logos/AmericanExpressBrand'
      ),
  ),
  null,
);
const VorkasseBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VorkasseBrandIcon" */ '../Atoms/Logos/logos/VorkasseBrand'
      ),
  ),
  null,
);
const VorkasseBrandIconCZ = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VorkasseBrandIconCZ" */ '../Atoms/Logos/logos/VorkasseBrandCZ'
      ),
  ),
  null,
);
const VorkasseBrandIconHR = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VorkasseBrandIconHR" */ '../Atoms/Logos/logos/VorkasseBrandHR'
      ),
  ),
  null,
);
const VorkasseBrandIconHU = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VorkasseBrandIconHU" */ '../Atoms/Logos/logos/VorkasseBrandHU'
      ),
  ),
  null,
);
const VorkasseBrandIconSK = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VorkasseBrandIconSK" */ '../Atoms/Logos/logos/VorkasseBrandSK'
      ),
  ),
  null,
);
const VorkasseBrandIconSI = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VorkasseBrandIconSI" */ '../Atoms/Logos/logos/VorkasseBrandSI'
      ),
  ),
  null,
);
const VisaBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VisaBrandIcon" */ '../Atoms/Logos/logos/VisaBrand'
      ),
  ),
  null,
);
const VisaBrandElectronIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VisaBrandElectronIcon" */ '../Atoms/Logos/logos/VisaBrandElectron'
      ),
  ),
  null,
);
const VPayBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VPayBrandIcon" */ '../Atoms/Logos/logos/VPayBrand'
      ),
  ),
  null,
);
const PayPalBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PayPalBrandIcon" */ '../Atoms/Logos/logos/PayPalBrand'
      ),
  ),
  null,
);
const PaydirektBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PaydirektBrandIcon" */ '../Atoms/Logos/logos/PaydirektBrand'
      ),
  ),
  null,
);
const MastercardBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MastercardBrandIcon" */ '../Atoms/Logos/logos/MastercardBrand'
      ),
  ),
  null,
);
const KlarnaBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "KlarnaBrandIcon" */ '../Atoms/Logos/logos/KlarnaBrand'
      ),
  ),
  null,
);
const KlarnaBrandSofortueberweisungIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "KlarnaBrandSofortueberweisungIcon" */ '../Atoms/Logos/logos/KlarnaBrandSofortueberweisung'
      ),
  ),
  null,
);
const FlaskIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "FlaskIcon" */ '../Atoms/Icon/dm/Flask'),
  ),
  null,
);
const ApplePayBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ApplePayBrandIcon" */ '../Atoms/Logos/logos/ApplePayBrand'
      ),
  ),
  null,
);
const GooglePayBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "GooglePayBrandIcon" */ '../Atoms/Logos/logos/GooglePayBrand'
      ),
  ),
  null,
);
const MaestroBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MaestroBrandIcon" */ '../Atoms/Logos/logos/MaestroBrand'
      ),
  ),
  null,
);
const GiropayPaydirektBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "GiropayPaydirektBrandIcon" */ '../Atoms/Logos/logos/GiropayPaydirektBrand'
      ),
  ),
  null,
);
const NachnahmeBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "NachnahmeBrandIcon" */ '../Atoms/Logos/logos/NachnahmeBrand'
      ),
  ),
  null,
);
const NachnahmeBrandIconCZ = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "NachnahmeBrandIconCZ" */ '../Atoms/Logos/logos/NachnahmeBrandCZ'
      ),
  ),
  null,
);
const NachnahmeBrandIconHR = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "NachnahmeBrandIconHR" */ '../Atoms/Logos/logos/NachnahmeBrandHR'
      ),
  ),
  null,
);
const NachnahmeBrandIconHU = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "NachnahmeBrandIconHU" */ '../Atoms/Logos/logos/NachnahmeBrandHU'
      ),
  ),
  null,
);
const NachnahmeBrandIconSI = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "NachnahmeBrandIconSI" */ '../Atoms/Logos/logos/NachnahmeBrandSI'
      ),
  ),
  null,
);
const NachnahmeBrandIconSK = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "NachnahmeBrandIconSK" */ '../Atoms/Logos/logos/NachnahmeBrandSK'
      ),
  ),
  null,
);
const PackageSearchIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PackageSearchIcon" */ '../Atoms/Icon/dm/PackageSearch'
      ),
  ),
  null,
);
const HouseIcon = withSuspense(
  lazy(
    () => import(/* webpackChunkName: "HouseIcon" */ '../Atoms/Icon/dm/House'),
  ),
  null,
);
const PayUBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PayUBrandIcon" */ '../Atoms/Logos/logos/PayUBrand'
      ),
  ),
  null,
);
const BlikBrandIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "BlikBrandIcon" */ '../Atoms/Logos/logos/BlikBrand'
      ),
  ),
  null,
);
const PackagingReturnIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PackagingReturnIcon" */ '../Atoms/Icon/dm/PackagingReturn'
      ),
  ),
  null,
);
const AustriaFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "AustriaFlagIcon" */ '../Atoms/Icon/flags/Austria'
      ),
  ),
  null,
);
const CroatiaFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CroatiaFlagIcon" */ '../Atoms/Icon/flags/Croatia'
      ),
  ),
  null,
);
const GermanyFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "GermanyFlagIcon" */ '../Atoms/Icon/flags/Germany'
      ),
  ),
  null,
);
const HungaryFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "HungaryFlagIcon" */ '../Atoms/Icon/flags/Hungary'
      ),
  ),
  null,
);
const SloveniaFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "SloveniaFlagIcon" */ '../Atoms/Icon/flags/Slovenia'
      ),
  ),
  null,
);
const PolandFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PolandFlagIcon" */ '../Atoms/Icon/flags/Poland'
      ),
  ),
  null,
);
const CzechFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CzechFlagIcon" */ '../Atoms/Icon/flags/Czech'
      ),
  ),
  null,
);
const SlovakiaFlagIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "SlovakiaFlagIcon" */ '../Atoms/Icon/flags/Slovakia'
      ),
  ),
  null,
);

const ChangingTableIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ChangingTableIcon" */ '../Atoms/Icon/storeProperties/ChangingTable'
      ),
  ),
  null,
);

const Co2CartridgeIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "Co2CartridgeIcon" */ '../Atoms/Icon/storeProperties/Co2Cartridge'
      ),
  ),
  null,
);

const CubesWithLettersIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "CubesWithLettersIcon" */ '../Atoms/Icon/storeProperties/CubesWithLetters'
      ),
  ),
  null,
);

const MomHoldingBabyIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "MomHoldingBabyIcon" */ '../Atoms/Icon/storeProperties/MomHoldingBaby'
      ),
  ),
  null,
);

const ParkingIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "ParkingIcon" */ '../Atoms/Icon/storeProperties/Parking'
      ),
  ),
  null,
);

const PassportPhotoIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PassportPhotoIcon" */ '../Atoms/Icon/storeProperties/PassportPhoto'
      ),
  ),
  null,
);

const PhotoCameraIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "PhotoCameraIcon" */ '../Atoms/Icon/storeProperties/PhotoCamera'
      ),
  ),
  null,
);

const RomperIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "RomperIcon" */ '../Atoms/Icon/storeProperties/Romper'
      ),
  ),
  null,
);

const StockingIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "StockingIcon" */ '../Atoms/Icon/storeProperties/Stocking'
      ),
  ),
  null,
);

const VacuumCleanerIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "VacuumCleanerIcon" */ '../Atoms/Icon/storeProperties/VacuumCleaner'
      ),
  ),
  null,
);

const WcIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "WcIcon" */ '../Atoms/Icon/storeProperties/Wc'
      ),
  ),
  null,
);

const WheelChairRightIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "WheelChairRightIcon" */ '../Atoms/Icon/storeProperties/WheelChairRight'
      ),
  ),
  null,
);

const WheelChairWcIcon = withSuspense(
  lazy(
    () =>
      import(
        /* webpackChunkName: "WheelChairWcIcon" */ '../Atoms/Icon/storeProperties/WheelChairWc'
      ),
  ),
  null,
);

export {
  ActiveBeautyBrandIcon,
  AlverdeBrandIcon,
  AndroidShareIcon,
  AngleDownIcon,
  AngleLeftIcon,
  AngleRightIcon,
  AngleUpIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  BagExpressIcon,
  BestRatedIcon,
  BarcodeIcon,
  CardsIcon,
  CartIcon,
  CartEuroIcon,
  CatHeadIcon,
  ChangingTableIcon,
  CheckIcon,
  CheckCircleIcon,
  CheckCircleInvertedIcon,
  ClockIcon,
  ClockAliveIcon,
  Co2CartridgeIcon,
  CoinStackIcon,
  ControlsIcon,
  CouponIcon,
  CrossIcon,
  CrossCircleIcon,
  CrossCircleInvertedIcon,
  CrosshairIcon,
  CubesWithLettersIcon,
  DmActiveBeautyBrandIcon,
  DmActiveBeautySquareBrandIcon,
  DmBrandIcon,
  DmBrandClaimIcon,
  DmBrandClaimNegIcon,
  DmBrandMonoIcon,
  DmBrandSmartphoneIcon,
  DmBusinessBrandIcon,
  DmBusinessBrandMonoIcon,
  DmFriseurstudioBrandIcon,
  DmImmerguenstigBrandIcon,
  DmImmerguenstigBrandIconBA,
  DmImmerguenstigBrandIconBG,
  DmImmerguenstigBrandIconCZ,
  DmImmerguenstigBrandIconHR,
  DmImmerguenstigBrandIconHU,
  DmImmerguenstigBrandIconIT,
  DmImmerguenstigBrandIconPL,
  DmImmerguenstigBrandIconSI,
  DmImmerguenstigBrandIconSK,
  DmKosmetikstudioBrandIcon,
  DmMiteinanderBrandMonoIcon,
  DmMiteinanderBrandMonoIconBA,
  DmMiteinanderBrandMonoIconBG,
  DmMiteinanderBrandMonoIconCZ,
  DmMiteinanderBrandMonoIconHU,
  DmMiteinanderBrandMonoIconRO,
  DmMiteinanderBrandMonoIconSI,
  DmMiteinanderBrandMonoIconSK,
  DmProdukttesterLogoIcon,
  DmProdukttesterLogoIconHR,
  DmProdukttesterLogoIconHU,
  DmProdukttesterLogoIconSK,
  DmProdukttesterLogoIconSL,
  DmStudioBrandIcon,
  ExclamationCircleIcon,
  ExclamationCircleStrokeIcon,
  ExpressDeliveryIcon,
  EyeIcon,
  EyeStrokeIcon,
  FacebookBrandIcon,
  GearIcon,
  GiftIcon,
  GiftCardIcon,
  GlueckskindBrandIcon,
  GlueckskindBrandMonoIcon,
  GlueckskindBrandSquareIcon,
  GlueckskindBrandMonoSquareIcon,
  HairdresserCosmeticToolsIcon,
  HeartIcon,
  HeartStrokeIcon,
  InfoIcon,
  InfoStrokeIcon,
  LetterCheckIcon,
  ListCheckIcon,
  MailIcon,
  MailCheckIcon,
  MailQuestionMarkIcon,
  MapsMarkerIcon,
  MapsMarkerHeartIcon,
  MapsMarkerCheckIcon,
  MapsMarkerCheckHeartIcon,
  MapsMarkerCrossIcon,
  MapsMarkerCrossHeartIcon,
  MapsMarkerDmBrandIcon,
  MapsMarkerDmBrandHeartIcon,
  MapsMarkerHouseIcon,
  MeinDmAppIcon,
  MenuIcon,
  MinusIcon,
  MomHoldingBabyIcon,
  NewIcon,
  PackageArrowIcon,
  PackageCloseIcon,
  PackageCrossIcon,
  PackageOpenIcon,
  ParkingIcon,
  PassportPhotoIcon,
  PaybackBrandIcon,
  PaybackBrandBigIcon,
  PaybackLogotypeIcon,
  PencilIcon,
  PhotoAlbumIcon,
  PhotoCameraIcon,
  PlayIcon,
  PlusIcon,
  PlusCircleIcon,
  PoweredByDmBrandIcon,
  ProductsIcon,
  QuadArrowRightIcon,
  QuadArrowTopIcon,
  QuestionCircleIcon,
  RomperIcon,
  SearchIcon,
  SearchCategoryIcon,
  SeinzBrandIcon,
  SeinzBrandWhiteIcon,
  StarIcon,
  StockingIcon,
  StoreIcon,
  StoreArrowIcon,
  StoreCheckIcon,
  StoreExpressDeliveryIcon,
  TrashIcon,
  TruckIcon,
  UnserDmBrandIcon,
  UserIcon,
  UserCheckIcon,
  UserCrossIcon,
  UsersIcon,
  VacuumCleanerIcon,
  VirusIcon,
  WhatsappBrandIcon,
  PaperBagIcon,
  AmericanExpressBrandIcon,
  VorkasseBrandIcon,
  VorkasseBrandIconCZ,
  VorkasseBrandIconHR,
  VorkasseBrandIconHU,
  VorkasseBrandIconSK,
  VorkasseBrandIconSI,
  VisaBrandIcon,
  VisaBrandElectronIcon,
  VPayBrandIcon,
  WcIcon,
  WheelChairRightIcon,
  WheelChairWcIcon,
  PayPalBrandIcon,
  PaydirektBrandIcon,
  MastercardBrandIcon,
  KlarnaBrandIcon,
  KlarnaBrandSofortueberweisungIcon,
  FlaskIcon,
  ApplePayBrandIcon,
  GooglePayBrandIcon,
  MaestroBrandIcon,
  GiropayPaydirektBrandIcon,
  NachnahmeBrandIcon,
  NachnahmeBrandIconCZ,
  NachnahmeBrandIconHR,
  NachnahmeBrandIconHU,
  NachnahmeBrandIconSI,
  NachnahmeBrandIconSK,
  PackageSearchIcon,
  HouseIcon,
  PayUBrandIcon,
  BlikBrandIcon,
  PackagingReturnIcon,
  AustriaFlagIcon,
  CroatiaFlagIcon,
  GermanyFlagIcon,
  HungaryFlagIcon,
  SloveniaFlagIcon,
  PolandFlagIcon,
  CzechFlagIcon,
  SlovakiaFlagIcon,
};
